// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3O_9Y","approved":"Status_approved__3McY-","rejected":"Status_rejected__1uuNz","expired":"Status_expired__4bIxt","label":"Status_label__2ljcX"};